/**
 * Cards component
 * 
 */

import React, { PureComponent } from 'react';

// Components

import CardSection from './card-section';
import CardWidget from './card-widget';

export default class Cards extends PureComponent {

	render() {
		
		const { items, data, template } = this.props;

		switch (template) {
			case 'section_services':
				return (

					<div className="cards cards-deck">
						{
							items.map((item, i) => {

								return <CardWidget key={'card-' + i} data={item} />
							})
						}
					</div>
				)

			case 'section_work':
				return (

					<div className="cards cards-deck cards-brick-deck">

						<div className="cards-header">
							<h2>{data.title}</h2>
							<p>{data.lead}</p>
						</div>

						{
							items.map((item, i) => {

								return <CardWidget key={'card-' + i} data={item} />
							})
						}

					</div>
				)
			
			case 'section_features':
				return (

					<div className="cards-grid">
						{
							items.map((item, i) => {

								return <CardSection key={'card-' + i} data={item} count={i} />
							})
						}
					</div>
				)
			
			default:
				return ''
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/cards/cards.js